export default __webpack_public_path__ + "static/media/s1-bg-2x.dc6a8235.png";